export const TEST_ID = 'serviceNotesField';

// Sizes the textarea to ~4 visible lines so it reads as a text box without a
// fixed CSS height (content can still grow the box naturally).
export const NOTES_ROWS = 4;
